import * as t from "io-ts";
import { isoDateTime } from "./date-time";
import nullable from "./nullable";
const driverActivityResponseT = t.strict({
    logins: t.record(t.string, t.strict({
        driverId: t.string,
        truckId: t.string,
        trailerId: nullable(t.string),
        loggedInAt: isoDateTime,
    })),
    stopsCompleted: t.array(t.strict({
        stopId: t.string,
        completedAt: isoDateTime,
        driverId: t.string,
    })),
    stopsArrived: t.array(t.strict({
        stopId: t.string,
        arrivedAt: isoDateTime,
        driverId: t.string,
    })),
    stopsDeparted: t.array(t.strict({
        stopId: t.string,
        departedAt: isoDateTime,
        driverId: t.string,
    })),
});
export { driverActivityResponseT };
//# sourceMappingURL=driver-activity.js.map